/* eslint-disable import/extensions */
/* eslint-disable unicorn/consistent-function-scoping */

import React, { useState } from 'react';
import { Box, Button, Grid, TextField, InputLabel, Select, MenuItem, Autocomplete, Typography, IconButton, RadioGroup, FormControlLabel } from '@mui/material';
import { useDispatch } from 'react-redux';
import clsx from 'clsx';
import useStyles from './style';
import FileUploader from '../../file-loader';
import AcceptIcon from '../../../assets/icons/accept-icon';
import CancelIcon from '../../../assets/icons/cancel-icon';
import { enqueueSnackbarAction } from '../../../store/snackbar/actions';
import { AppState, AppThunkDispatch } from '../../../store';
import FileTypeConfigurationV2 from '../../../services/file-type-configurations-v2';
import { downloadBulkFileTemplate } from '../../bulk-device-management/csv-template';

const BulkFileTypeConfiguration = () => {
  const [fileObject, setFileObject] = useState<FileList | null>();
  const [isUploadFile, setIsUploadFile] = useState<Boolean>(false);
  const [pushFileName, setPushFileName] = useState<string>('');
  const [fileToPush, setFileToPush] = useState<any>();
  const [uploadedFileName, setUploadedFileName] = useState<string>();
  const classes = useStyles();
  const dispatch = useDispatch();
  const boxProperties = {
    p: 3,
    className: classes.box,
  };
  
  // eslint-disable-next-line unicorn/consistent-function-scoping
  const handleFile = (data: any) => {
    if (!data || !data.length) return;
    const selectedFile = data[0];
    if (!selectedFile.name.endsWith('.csv')) {
      dispatch(
        enqueueSnackbarAction({
          message: 'Only CSV files are allowed!',
          options: { variant: 'error' },
        }),
      );
     return;
    }
   setFileObject(data);
   setUploadedFileName(data[0].name);
  };
  const clearFile = () => {
    setFileObject(null);
    setIsUploadFile(false);
    setUploadedFileName('');
  };
  const uploadFile = () => async (dispatch: AppThunkDispatch, getState: () => AppState) => {
    if (!fileObject || !fileObject[0]) return;
    const {
      login: { client, envVariables },
    } = getState();
    const fileTypeConfigurationV2 = new FileTypeConfigurationV2(
      client,
      envVariables.fileTypeConfigV2BaseUrl,
    );
    try {
      const result = await fileTypeConfigurationV2.uploadBulkCSV(fileObject[0]);
      dispatch(
        enqueueSnackbarAction({
          message: 'File uploaded successfully!',
          options: { variant: 'success' },
        })
      );
    } catch (error) {
      dispatch(
        enqueueSnackbarAction({
          message: 'File upload failed!',
          options: { variant: 'error' },
        })
      );
      console.error('Upload error:', error);
    }
    clearFile();
  };

return(
  <>
    <Grid container direction="row" alignItems="stretch">
      <Grid item xs={12} md={6}>      
          <div className={classes.actionRow}>
        <FileUploader
          text="Choose File"
          buttonId="config-files-upload"
          handleFile={handleFile}
          accept='.csv'
          multiple
        />
        <Button
          className={classes.confirm}
          variant="outlined"
          size="small"
          onClick={() => setIsUploadFile(true)}
          disabled={!fileObject}
        >
          Upload File
        </Button>
        {fileObject && isUploadFile && (
          <Box className={classes.confirm} display="flex" alignItems="center">
            <Typography>Are you sure?</Typography>
            <IconButton  onClick={() => dispatch(uploadFile())} size="large">
              <AcceptIcon />
            </IconButton>
            <IconButton      
              onClick={() => clearFile()}
              aria-label="edit"
              size="large">
              <CancelIcon />
            </IconButton>
          </Box>
        )}
          <Button
            className={clsx(classes.button, classes.buttonMargin)}
            variant="outlined"
            size="small"
            onClick={() => downloadBulkFileTemplate()}
          >
            Download Template
          </Button>
        </div>
         <Box mt={1}>{uploadedFileName}</Box>
      </Grid>
    </Grid>
  </>
)
};

export default BulkFileTypeConfiguration;
